
import { defineComponent } from "vue";
//import KTNotificationsMenu from "@/layout/header/partials/NotificationsMenu.vue";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";

export default defineComponent({
  name: "topbar",
  components: {
    //KTNotificationsMenu,
    KTUserMenu,
  },
});
